<template>
  <fieldset class="form-item-fieldset">
    <legend class="form-item-fieldset__legend">
      {{ element.metadata?.title }}
    </legend>
    <form-item v-for="child in element.elements" :key="child.key" :element="child" :form-errors="formErrors" />
  </fieldset>
</template>
<script setup lang="ts">
import { type WebformElementFieldsetFragment, type WebformSubmissionValidationErrorFragment } from '#graphql-operations'

export interface Props {
  element: WebformElementFieldsetFragment
  formErrors?: WebformSubmissionValidationErrorFragment[]
}

withDefaults(defineProps<Props>(), {
  formErrors: () => {
    return []
  }
})
</script>

<style lang="scss">
@use "~/assets/sass/tools";

.form-item-fieldset {
  padding: 0;
  border: 0;
  @include tools.fieldset;

  &__legend {
    @include tools.fieldset-legend;
    @include tools.typo-heading-medium;
  }
}
</style>
